export default __webpack_public_path__ + "static/media/change-color.d2884f71.png";